/* Suggested path: frontend/src/hooks/useSkills.js
   --------------------------------------------------
   Single fetch point for the Supabase `skills` table, shared by
   Dashboard.jsx and Skills.jsx so neither carries its own hardcoded
   skill list anymore. Matches the real column names from your
   skills_rows.json export (id, name, tagline, description, lessons,
   exercises, status, card_shape, color_*, route, landing_route, etc.).
*/
import { useState, useEffect } from 'react';
import { supabase } from '@services/api.js';

export const useSkills = () => {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error: fetchError } = await supabase
          .from('skills')
          .select('*')
          .order('order_display', { ascending: true });
        if (fetchError) throw fetchError;
        if (!cancelled) setSkills(data || []);
      } catch {
        if (!cancelled) setError('Unable to load skills.');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return { skills, loading, error };
};
